import { render } from "./werkzaamheden.vue?vue&type=template&id=61446a9d"
import script from "./werkzaamheden.vue?vue&type=script&lang=js"
export * from "./werkzaamheden.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/widgets/werkzaamheden.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61446a9d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61446a9d', __exports__)) {
    console.log('reload')
    api.reload('61446a9d', __exports__)
  }
  
  module.hot.accept("./werkzaamheden.vue?vue&type=template&id=61446a9d", () => {
    console.log('re-render')
    api.rerender('61446a9d', render)
  })

}


export default __exports__